module.exports = __webpack_public_path__ + "static/media/icon-computer.2945a97e.svg";